// Core
import React from 'react';
import { useQuery } from 'react-query';
import { Box, Button, Flex, Text, Grid, Divider, Image, useColorMode } from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';

// Components
import { StarsIcon } from 'components/Icons/Icons';

const PrivacyPolicy = () => {
  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const { data, isLoading } = useQuery({
    queryKey: ['privacy'],
    queryFn: async () => {
        const response = await apiService.getPrivacyPolicy();
        return response.data;
    },
    refetchOnWindowFocus: false
  });

  return (
  	<Box m={{base: '-40px auto 100px auto', md: '37px auto 100px auto'}}>
  		<Flex gap={{base: '8px', md: '26px'}} m="82px 0 46px 0" w="100%" alignItems="center" textAlign="center" justifyContent="center">
      	<StarsIcon fontSize={{base: '28px', md: '43px'}} />
      	{ isDark && <Box bg="#099BFF"
          className="animation-opacity" 
      		filter="blur(40px)" w="50%" h="40px" left="50%" borderRadius="full"
      		transform="translate(-50%, 40px)" position="absolute" zIndex="-1" />}
      	<Text variant="header" fontSize={{base: '46px', md: '64px', lg: '72px'}}>Privacy Policy</Text>
      	<StarsIcon fontSize={{base: '28px', md: '43px'}} />
      </Flex>

      <Box maxW="744px" m="0px auto">
    		{ !isLoading && data && (
  			   <Box dangerouslySetInnerHTML={{ __html: data?.content?.html }} />
    		)}
  		</Box>
  	</Box>
  );
};

export default PrivacyPolicy;